import '@babel/polyfill'
import Vue from 'vue'
import './plugins/vuetify'
import './plugins/axios'
import '@/plugins/moment'
import axios from 'axios'
import App from './App.vue'
import router from './router'
import store from './store'
import VeeValidate from 'vee-validate'
import sv from 'vee-validate/dist/locale/sv'
import en from 'vee-validate/dist/locale/en'
import i18n from './lang/lang'
import '@/filters/date'

Vue.config.productionTip = false
axios.defaults.baseURL = process.env.VUE_APP_BASE_URL_API

Vue.use(VeeValidate, {
  // i18n,
  dictionary: {
    sv: sv,
    en: en
  }
})

const dictionary = {
  sv: {
    messages: {
      min_value: (field, input) => {
        return `Fältet ${field} kan inte vara under ${input[0]}`
      },
      max_value: (field, input) => {
        return `Fältet ${field} kan inte vara över ${input[0]}`
      }
    }
  }
}

VeeValidate.Validator.localize('sv', dictionary.sv)

new Vue({
  router,
  store,
  i18n,
  render: h => h(App)
}).$mount('#app')
